<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
html {
  background-color: rgb(44, 51, 56) !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?465af7b6